<div *transloco="let t" class="flex flex-col gap-4 py-3">
  <div class="my-5 flex flex-col gap-6 animate-in fade-in slide-in-from-top-1 xl:flex-row xl:items-center">
    <div class="flex-1">
      <h1 tuiTitle="l">
        <span class="font-medium text-text-brand-primary" data-testid="home-greeting">
          {{ t('Bonjour {{name}}', { name: user.firstName }) }}
        </span>
        <span tuiSubtitle>{{ t('Bienvenue sur votre espace sécurisé') }}</span>
      </h1>
    </div>

    <div class="flex flex-row flex-wrap items-center gap-3">
      <button appearance="outline" data-testid="profile-button" tuiButton type="button" (click)="openAccount()">
        {{ t('Modifier mon profil') }}
      </button>
      <button
        class="max-xl:order-first"
        data-testid="create-sequence"
        tuiButton
        type="button"
        (click)="createSequence()">
        {{ t('Créer une séquence') }}
      </button>
    </div>
  </div>

  <div appearance="outline" class="flex flex-col gap-3 animate-in fade-in slide-in-from-bottom-1" tuiCardLarge>
    <p>{{ t('Mes statistiques') }}</p>
    @if (userStatistics$ | async; as userStatistics) {
      <div class="grid items-stretch gap-4 lg:grid-cols-3">
        @for (item of stats; track item.label) {
          <div
            class="group flex cursor-pointer items-center gap-4 rounded-xl bg-opacity-50 p-5 transition-all hover:-translate-y-0.5 hover:bg-opacity-100 hover:shadow-xl active:brightness-90 lg:p-6"
            [attr.data-testid]="item.label"
            [ngClass]="
              {
                pixablue: 'bg-blue-100 text-blue-900 shadow-blue-100/20!',
                pixapurple: 'bg-purple-100 text-purple-900 shadow-purple-100/20!',
                pixared: 'bg-pink-100 text-pink-900 shadow-pink-100/20!',
              }[item.color]
            "
            [routerLink]="['/client', clientCode$ | async, item.link]">
            <div class="flex flex-1 flex-col gap-2">
              <p class="leading-tight">{{ t(item.label) }}</p>
              <div class="flex items-center gap-2">
                <tui-icon class="h-8 w-8" [icon]="item.icon" />
                <p class="text-3xl tracking-tight">{{ userStatistics[item.value] }}</p>
              </div>
            </div>
            <tui-icon class="opacity-50 group-hover:opacity-100" icon="@tui.chevron-right" />
          </div>
        }
      </div>
    } @else {
      <pxc-loader />
    }
  </div>

  <div class="my-5 flex flex-col gap-2 animate-in fade-in slide-in-from-top-1">
    <h5 tuiTitle="m">
      {{ t("Besoin d'aide ?") }}
      <span tuiSubtitle>{{ t('Notre équipe est à votre disposition pour vous aider.') }}</span>
    </h5>
    <div class="mt-2 flex flex-col gap-6 md:flex-row md:items-center">
      @for (item of helpActions; track item.id) {
        <ng-container *ngTemplateOutlet="helpItem; context: item" />
      }
    </div>
  </div>
</div>

<ng-template #helpItem let-execute="execute" let-icon="icon" let-label="label">
  <a appearance="flat" class="flex items-center gap-2" target="_blank" tuiLink (click)="execute()">
    <tui-icon class="h-5 w-5" [icon]="icon" />
    {{ label }}
  </a>
</ng-template>
